import CurriculumSatisfaction from './CurriculumSatisfaction.container';
export default CurriculumSatisfaction;
